import { createNamedAction } from 'helpers/ActionUtil'

import {
  RUN_RISK_VALIDATION,
  OVERVIEW_UPDATE_STATE,
  OVERVIEW_ADD_MEMORY,
  OVERVIEW_REFRESH_MEMORY,
  UPDATE_STATE_ENTIRE_OBJ,
  OPEN_MEMORY_BROWSER_WITH_FILTER,
  TOGGLE_POPUP,
  TOGGLE_FILTER,
  PART_TYPE,
  INITIALIZE_FILTER,
  INITIALIZE_CONFIG,
  UPDATE_CONFIG_SELECTION,
  UPDATE_CONFIG_SOURCE,
  ADD_CONFIG,
  EDIT_CONFIG,
  DELETE_PART,
  UPDATE_CURRENT_CONFIG,
  REFRESH_FILTER,
  PHASE_COUNT,
  UPDATE_PHASE_COUNT,
  SELECT_FILTER,
  DELETE_FILTER,
  UPDATE_EDP_PEAK,
  UPDATE_EDP_CONTINUOUS,
  UPDATE_OUTPUT_VOLTAGE,
  RESET_FILTER,
  PART_NUMBER,
  VENDOR_NAME,
  EFFICIENCY,
  UPDATE_EFFICIENCY,
  IS_EDIT_PART,
  IS_ADD_PART
} from './constants'


export const runRiskValidation = () => ({ type: RUN_RISK_VALIDATION })

export const overviewUpdateState = (state, newValue) => {
  return {
    type: OVERVIEW_UPDATE_STATE,
    state,
    newValue
  }
}

export const addMemory = () => {
  return {
    type: OVERVIEW_ADD_MEMORY
  }
}

export const refreshMemory = () => {
  return {
    type: OVERVIEW_REFRESH_MEMORY
  }
}

export const updateStateEntireObj = (stateList, valueObj) => {
  return {
    type: UPDATE_STATE_ENTIRE_OBJ,
    stateList,
    valueObj
  }
}

export const openMemoryBrowserWithFilter = (categoryKey) => {
  return {
    type: OPEN_MEMORY_BROWSER_WITH_FILTER,
    categoryKey
  }
}

export const addConfig = (configs) => {
  return {
    type: ADD_CONFIG,
    configs,
  }
}

export const editConfig = (id, configs) => {
  return {
    type: EDIT_CONFIG,
    id,
    configs
  }
}

export const deletePart = (deleteId, railType, hasId) => {
  return {
    type: DELETE_PART,
    deleteId,
    railType,
    hasId
  }
}

export const isEditPart = (value) => {
  return {
    type: IS_EDIT_PART,
    value,
  }
}

export const isAddPart = (value) => {
  return {
    type: IS_ADD_PART,
    value,
  }
}

export const updatePhaseCount = (id, railType, value, hasId) => {
  return {
    type: UPDATE_PHASE_COUNT,
    id,
    railType,
    value,
    hasId
  }
}

export const updateEfficiency = (id, railType, value, hasId) => {
  return {
    type: UPDATE_EFFICIENCY,
    id,
    railType,
    value,
    hasId
  }
}

export const updateEdpPeak = (value) => {
  return {
    type: UPDATE_EDP_PEAK,
    value,
  }
}

export const updateEdpContinuous = (value) => {
  return {
    type: UPDATE_EDP_CONTINUOUS,
    value,
  }
}

export const updateOutputVoltage = (value) => {
  return {
    type: UPDATE_OUTPUT_VOLTAGE,
    value,
  }
}

/*
  UI State Related
*/

export const togglePopup = () => {
  return {
    type: TOGGLE_POPUP,
  }
}

export const updateConfigSelection = (newConfig) => {
  return {
    type: UPDATE_CONFIG_SELECTION,
    newConfig
  }
}

export const updateConfigSource = (newConfig) => {
  return {
    type: UPDATE_CONFIG_SOURCE,
    newConfig
  }
}

export const updateCurConfig = (curConfig) => {
  return {
    type: UPDATE_CURRENT_CONFIG,
    curConfig
  }
}

/*
  Filter Related
*/

export const selectFilter = (filterType) => {
  return {
    type: SELECT_FILTER,
    filterType,
  }
}

export const deleteFilter = (index) => {
  return {
    type: DELETE_FILTER,
    index
  }
}

export const resetFilter = (defaultFilter) => {
  return {
    type: RESET_FILTER,
    defaultFilter,
  }
}


const initFilter = (filters) => {
  return {
    type: INITIALIZE_FILTER,
    filters,
  }
}

const updateFilter = (index, value) => {
  return {
    type: TOGGLE_FILTER,
    index,
    value
  }
}

const refreshFilter = () => {
  return {
    type: REFRESH_FILTER
  }
}

export const getUiActions = (uiPath) => {
  const createToggleAction = (type) => {
    return createNamedAction(type + uiPath, updateFilter)
  }
  const createInitAction = (type) => {
    return createNamedAction(type + uiPath, initFilter)
  }
  const createRefreshAction = (type) => {
    return createNamedAction(type + uiPath, refreshFilter)
  }
  const createInitFilterAction = (filters) => {
    const initVendorName = createInitAction(VENDOR_NAME)
    const initEfficiency = createInitAction(EFFICIENCY)    
    const initPartNumber = createInitAction(PART_NUMBER)
    const initPartType = createInitAction(PART_TYPE)
    const initPhaseCount = createInitAction(PHASE_COUNT)

    return () => {
      return (dispatch) => {
        dispatch(initPartType(filters.vendorName))
        dispatch(initPartType(filters.efficiency))
        dispatch(initPartType(filters.partNumber))
        dispatch(initPartType(filters.partType))
        dispatch(initPhaseCount(filters.phaseCount))
        dispatch(initEfficiency(filters.efficiency))
      }
    }
  }
  const createRefreshFilterAction = () => {
    const refreshVendorName = createRefreshAction(VENDOR_NAME)
    const refreshEfficiency = createRefreshAction(EFFICIENCY)
    const refreshPartNumber = createRefreshAction(PART_NUMBER)
    const refreshPartType = createRefreshAction(PART_TYPE)
    const refreshPhaseCount = createRefreshAction(PHASE_COUNT)

    return () => {
      return dispatch => {
        dispatch(refreshVendorName())
        dispatch(refreshEfficiency())
        dispatch(refreshPartNumber())
        dispatch(refreshPartType())
        dispatch(refreshPhaseCount())
      }
    }
  }

  return {
    toggleVendorName: createToggleAction(VENDOR_NAME),
    toggleEfficiency: createToggleAction(EFFICIENCY),
    togglePartNumber: createToggleAction(PART_NUMBER),
    togglePartType: createToggleAction(PART_TYPE),
    togglePhaseCount: createToggleAction(PHASE_COUNT),
    initFilters: createInitFilterAction,
    refreshFilters: createRefreshFilterAction(),
  }
}
